import { IBreadcrumb } from "@/study-search/interfaces/breadcrumb.interface";
import { Filter } from "@/study-search/models/filter/Filter";
import { PortalType } from "@studyportals/domain-client";
import { SearchPage } from "@/search-page";

const filterMap = new Map<string, string>([
	['online', 'Online Degrees'],
	['affordable', 'Affordable Degrees']
]);

export class BreadcrumbsFactory {
	public static constructHref(breadcrumb: IBreadcrumb): string {
		const portalSearchParam = BreadcrumbsFactory.mapPortalTypeToSearchParam();
		const searchRoute = `${window.location.origin}/search/${portalSearchParam}`;

		if (breadcrumb.isFirst) {
			return window.location.origin;
		}
		if (!breadcrumb.accumulatedFilters) {
			return searchRoute;
		}
		return `${searchRoute}/${breadcrumb.accumulatedFilters?.map((ac) => BreadcrumbsFactory.getFilterPath(ac))?.join('/') || ''}`;
	}


	public static generateBreadcrumbs(filters: Filter[]): IBreadcrumb[] {
		const breadcrumbs: IBreadcrumb[] = [{ name: 'Home', isFirst: true }, { name: 'Programmes' }];
		const selectedFilters = filters.filter((filter) => filter.values.length > 0);

		for (const [index, filter] of selectedFilters.entries()) {

			const filterName = BreadcrumbsFactory.getFilterValue(filter);
			const filterNameFromMap = filterMap.get(filterName.toLowerCase()) || filterName;
			const isQueryParam = BreadcrumbsFactory.isFilterQueryParam(filter);
			if(isQueryParam) continue;
			if(!filterName) continue;

			const accumulatedFilters = selectedFilters.slice(0, index + 1);
			breadcrumbs.push({ accumulatedFilters, name: filterNameFromMap, key: filter.key });
		}

		return breadcrumbs.map((b,i,a)=>BreadcrumbsFactory.flagLastBreadcrumb(b,i,a));
	}

	private static getFilterPath(filter: Filter): string {
		const filterOption = filter.definition?.getFilterOption(filter.values[0]);
		if (!filterOption || !filterOption?.optionPath) {
			return '';
		}
		if (filter.definition) {
			return filterOption.optionPath;
		}
		return filter.values[0];
	}

	private static mapPortalTypeToSearchParam(): string {
		switch (window.PortalType) {
			case PortalType.SHORT:
				return 'course';
			case PortalType.DISTANCE_LEARNING:
				return 'distance-learning';
			default:
				return window.PortalType;
		}
	}

	private static flagLastBreadcrumb(breadcrumb: IBreadcrumb, index: number, array: IBreadcrumb[]): IBreadcrumb {
		if (index === array.length - 1) {
			return { ...breadcrumb, isLast: true };
		}

		return breadcrumb;
	}

	private static getFilterValue(filter: Filter):string{
		const filterOption = filter.definition?.getFilterOption(filter.values[0]);
		if(!filterOption || !filterOption?.optionPath){
			return '';
		}
		if (filter.definition) {
			return filterOption.optionTitle ||
			filterOption.optionName ||
			filterOption.optionValue;
		}
		return filter.values[0];
	}

	private static isFilterQueryParam(filter: Filter): boolean {
		const routing = SearchPage.instance.routing;
		const currentRoute = routing.currentRoute.value;
		const query = Object.keys(currentRoute.query);
		return query.includes(filter.key);
	}
}